import { lazy } from 'react';

export const ReportsPageCategoryAsync = lazy(
    () => import('./ReportsPageCategory'),
);
